import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const MailService = {
  getTemplates() {
    return fetchWithToken(`${config().mailService}/template`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getRegistrations(clientId) {
    return fetchWithToken(`${config().mailService}/registration/${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  addRegistration(registration) {
    return fetchWithToken(`${config().mailService}/registration`, {
      method: 'POST',
      body: JSON.stringify(registration),
    }).then((response) => response.json())
  },
  deleteRegistration(registration) {
    return fetchWithToken(`${config().mailService}/registration/${registration.idRegistration}`, {
      method: 'DELETE',
    }).then((response) => response.json())
  },
}
